import { Input } from 'semantic-ui-react';
import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const ComponentSize = styled.span`
  display: flex;
  flex-grow: 1;
`;

const CopyComponent = styled(Input).attrs({
  'data-study-copy-ryo-link': 'true',
})`
  &&& {
    margin-top: 15px;
    flex-grow: 1;

    &.ui.input input {
      color: ${(props) => props.theme.color.textLabel};
    }

    button.ui.icon.right.labeled {
      background: ${(props) => props.theme.color.button};
      border-bottom-left-radius: 0px;
      border-top-left-radius: 0px;
      color: ${(props) => props.theme.color.buttonText};
      font-weight: 500;
      padding-right: 40px !important;

      &:hover {
        background: ${(props) => props.theme.color.buttonHover};
      }

      :active {
        background: ${(props) => props.theme.color.buttonActive};
      }

      i {
        background: inherit;
      }
    }
  }
`;

const Text = styled(TextLayoutComponent)``;

export {
  ComponentSize,
  CopyComponent,
  Text,
};
